import { find } from 'lodash';
import { format, parse, eachHourOfInterval, addDays, compareDesc, isWithinInterval } from 'date-fns';

import { set, get } from "lodash";
import produce from "immer";


export function enhancedReducer(state, action) {
    if (action === undefined) return

    const { _path } = action;

    switch (action.type) {
        case 'text':
            const { _value } = action;
            return produce(state, draft => {
                set(draft, _path, _value);
            });
        case 'checkbox':
            return produce(state, draft => {
                set(draft, _path, !get(state, _path));
            })
        case 'seed':
            return {...state, ...action._value}
        case 'reset':
            return { ...action._value }
        default:
            throw new Error();

    }
}


export function findByHour(forecast) {
    const result = find(forecast, function (o) {
        return format(parse(o["periodo"], 'HH', new Date()), 'H') === format(new Date(), 'H')
    });

    if (!result) return forecast[forecast.length - 1];
    return result;
}

export function findByInterval(forecast) {
    return find(forecast, function (o) {
        return isWithinInterval(
            new Date(),
            { start: parse(o["periodo"].substring(0, 2), 'HH', new Date()), 
            end: parse(o["periodo"].substring(3, 4), 'HH', new Date()) }
        )
    });
}

export function getFaseOfDay(date) {
    if (format(date, 'H') >= 20 || format(date, 'H') <= 6) 
        return 'night'
    return 'morning'
}

export function getDateFromHourStr(h) {
    return parse(h, 'HH', new Date())
}

export function findByHourRange(forecast) {
    const currentHour = format(new Date(), 'H');

    return find(forecast, function (o) {
        let startInterval = parse(o["periodo"].substring(0, 2), 'HH', new Date());
        let endInterval = parse(o["periodo"].substring(2, 4), 'HH', new Date())

        if (compareDesc(startInterval, endInterval) === -1) 
            endInterval = addDays(endInterval, 1)

        var result = eachHourOfInterval({
            start: startInterval,
            end: endInterval
        })
        result.splice(-1,1)

        return result.map((date) => format(date, 'H')).includes(currentHour);
    });
}


export function convertArrayToObject(array, key, data={}) {
    const initialValue = {};
    const converted = array.reduce((obj, item) => {
        return {
            ...obj,
            [[item[key], item.parcel.id]]: { ...item, ...data },
        };
    }, initialValue);
    
    return converted
};


export function getLayerWithPriority(layers, prefer = null) {
    if (!layers || layers.length === 0) return null;
  
    let chosenLayer = null;
  
    // If prefer is set, try to find a layer that contains the preferred string in its name
    if (prefer) {
      for (const layer of layers) {
        if (layer.name.includes(prefer) && layer.menu_priority > 1) {
          if (!chosenLayer || layer.menu_priority < chosenLayer.menu_priority) {
            chosenLayer = layer;
          }
        }
      }
    }
  
    // If no suitable layer found, fallback to highest priority is_sentinel layer
    if (!chosenLayer) {
      for (const layer of layers) {
        if (layer.is_sentinel) {
          if (!chosenLayer || layer.menu_priority < chosenLayer.menu_priority) {
            chosenLayer = layer;
          }
        }
      }
    }

    // If no preferred layer found, fallback to highest menu_priority layer
    if (!chosenLayer) {
      for (const layer of layers) {
        if (layer.menu_priority && layer.menu_priority > 1) {
          if (!chosenLayer || layer.menu_priority > chosenLayer.menu_priority) {
            chosenLayer = layer;
          }
        }
      }
    }
  
    return chosenLayer || layers[1];
}